import api from '@/lib/api'
import { defineStore, acceptHMRUpdate } from 'pinia'
import { ref, watch } from 'vue'

export const useAnomaliesStore = defineStore('anomalies', () => {
  const startDate = new Date()
  const anomalies = ref([])
  const status = ref({ warning: false })
  const filters = ref({ startDate: new Date(startDate.setDate(startDate.getDate() - 7)), endDate: undefined })
  const loadingStuff = ref(false)

  const fetchAnomalies = async () => {
    loadingStuff.value = true
    anomalies.value = []
    if (filters.value.startDate) {
      const response = await api.anomalies.getAnomalies({
        startDate: new Date(filters.value.startDate).toISOString(),
        endDate: filters.value.endDate ? new Date(filters.value.endDate).toISOString() : ''
      })
      anomalies.value = response.map(el => {
        el.createddate = new Date(el.createddate)
        el.duration.milliseconds = Math.round(el.duration.milliseconds)
        // @ts-ignore
        const duration = (new Intl.DurationFormat('en', { style: 'narrow' }).format(el.duration)).split(' ')
        return { ...el, formattedDuration: duration[0] + ' ' + (duration[1] || '') }
      })
    }
    status.value.warning = anomalies.value.length && !anomalies.value[0].enddate
    loadingStuff.value = false
  }

  const updateStatus = (value) => {
    status.value.warning = value
  }

  watch(filters.value, fetchAnomalies)

  return {
    anomalies,
    status,
    filters,
    loadingStuff,
    updateStatus,
    fetchAnomalies
  }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useAnomaliesStore, import.meta.hot))
}
